export const Routes = {
  home: "/",
  printerQueue: "/PrinterQueueConfig",
  messageConfig: "/MessageConfiguration",
  addPrinterQueue: "/AddPrinterQueue",
  editPrinterQueue: "/EditPrinterQueue/:id",
};
